export const NewsPost_Data = {
    "we_have_arrived_uk": {
        N_Post_Title: "We have arrived United Kingdom",
        N_Post_Date: "14 September 2020",
        N_Post_Author: "Mr. Ashok Paun",
        N_Post_SHARE: "addtoany",
        N_Post_Content: (
            <>
                <p>
                    On completion of a successful year and a half of taking over the window covering market in GCC; Callistus Blinds has finally arrived in United Kingdom.
                </p>
                <p>
                    We have successfully launched ourselves in UK under the name Callistus UK Ltd. on 6th of August 2020.
                </p>
                <p>
                    A multinational brand with a vision to conquer the market in United Kingdom and Europe, Callistus Blinds comes with a range of 15 different products of window fashions with over more than 2000 fabric options to transform your interior in unimaginable astounding ways.
                </p>
                <p>
                    The company promises to give the people of UK and Europe quality products and best of customer service.
                </p>
            </>
        ),
        N_End_PostIMG: "/Assets/NewsImages/callistus_uk.webp"
    },

    "callistus-blinds-goes-international": {
        N_Post_Title: "Callistus Blinds goes International",
        N_Post_Date: "14 September 2020",
        N_Post_Author: "Mr. Ashok Paun",
        N_Post_SHARE: "addtoany",
        N_Post_Content: (
            <>
                <p>
                    After conquering the market of window covering in India under the brand name Marvel, Callistus Blinds has gone international by launching its venture in Sharjah UAE.
                </p>
                <p>
                    The company commenced operations in Sharjah at Saif zone under the name of Callistus Blinds Middle East FZE on the 16th of January, 2019.
                </p>
                <p>
                    Callistus has entered the GCC market with never before seen largest range of 15 products in window covering industry.
                </p>
                <p>
                    The Company not only caters to whole of GCC but also to United Kingdom and Europe from its setup at Sharjah.
                </p>
            </>
        ),
        N_End_PostIMG: "/Assets/NewsImages/callistus_dubai.webp"
    }
}